import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteAssetFeatureOptionSaga,
  getAssetFeatureOptionDetailsSaga,
  getAssetFeatureOptionListByFeatureIdSaga,
} from "src/store/asset-features-options/saga";
import {
  AssetFeatureOptionDetailDto,
  AssetFeatureOptionDto,
} from "src/store/asset-features-options/type";
import { getAssetFeatureDetailsSaga } from "src/store/asset-features/saga";
import { AssetFeatureDetailDto } from "src/store/asset-features/type";
import AssetFeatureOptionCreateForm from "./create";
import AssetFeatureOptionEditForm from "./edit";
const AssetFeatureOptionPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { featureId } = useParams<{ featureId: string }>();
  const [data, setData] = useState<AssetFeatureOptionDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<AssetFeatureOptionDetailDto>();
  const [feature, setFeature] = useState<AssetFeatureDetailDto>();
  const columns = [
    {
      text: t("AssetFeatureOption.Feature"),
      dataField: "FeatureName",
    },
    {
      text: t("AssetFeatureOption.OptionName"),
      dataField: "PicklistOptionName",
    },
  ];
  useEffect(() => {
    dispatch(
      getAssetFeatureDetailsSaga({
        payload: {
          onSuccess: (m, p) => setFeature(p),
          onError: () => {},
        },
        id: featureId,
      })
    );
  }, [dispatch, featureId]);
  return (
    <React.Fragment>
      {feature && (
        <>
          <MainPage
            title={t("AssetFeatureOption.PageTitle", { name: feature.Name })}
            metaTag={t("AssetFeatureOption.MetaTag", { name: feature.Name })}
            gridProps={{
              addTitle: t("AssetFeatureOption.AddButton").toString(),
              listData: data,
              columns: columns,
              setDataList: setData,
              paramsid: featureId,
              action: getAssetFeatureOptionListByFeatureIdSaga,
              onCreateClick: () => setShowCreate(true),
              editButton: {
                onClick: (id, data) => {
                  dispatch(
                    getAssetFeatureOptionDetailsSaga({
                      payload: {
                        onSuccess: (message, payload, response) => {
                          let currenctObject = payload;
                          currenctObject.Translates = response.Translates;
                          setSelected(currenctObject);
                          return setShowEdit(true);
                        },
                        onError: () => {},
                      },
                      id: id,
                    })
                  );
                },
              },
              deleteButton: {
                text: (id, data: AssetFeatureOptionDto) =>
                  t("AssetFeatureOption.DeleteQA", {
                    name: data.PicklistOptionName,
                  }),
                action: deleteAssetFeatureOptionSaga,
                onClick: (id, data) => setShowEdit(data),
              },
            }}
          />
          <AssetFeatureOptionCreateForm
            open={showCreate}
            feature={feature}
            onHide={() => setShowCreate(false)}
            onSuccessClick={(m) =>
              onSuccessClickFormBasicForm({
                dispatch: dispatch,
                message: m,
                action: getAssetFeatureOptionListByFeatureIdSaga,
                setDataList: setData,
                id: featureId,
              })
            }
          />
          {selected && (
            <AssetFeatureOptionEditForm
              data={selected}
              open={showEdit}
              onHide={() => {
                setShowEdit(false);
                return setSelected(undefined);
              }}
              onSuccessClick={(m) =>
                onSuccessClickFormBasicForm({
                  dispatch: dispatch,
                  message: m,
                  action: getAssetFeatureOptionListByFeatureIdSaga,
                  setDataList: setData,
                  id: featureId,
                })
              }
            />
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default AssetFeatureOptionPage;
